// application list api
export const onlineAdmissionList = 'admission/online-admission-application/list'

// application report api
export const applicationReportList = 'reports/application-report/list'

// application report api
export const instructorReportList = 'reports/instructor-attendance-report/list'
// resident report api
export const residentReportListApi = 'reports/resident-report/list'
// monthly resident-information report api
export const residentInformationReportListApi = 'reports/monthly-resident-information-report/list'
// resident report api
export const classReportListApi = 'reports/class-attendance-report/list'
// follow up report api
export const followupReportApi = 'reports/follow-up-report/list'
export const followupReportApi2 = 'reports/follow-up-report/individual-list'
// follow up report api
export const caseFileReportApi = 'reports/case-file-report/list'
export const caseFileReportApi2 = 'reports/case-file-report/individual-list'

// evaluation-management-report
export const evaluationReportApi = 'reports/evaluation-management-report/list'
export const evaluationReportApi2 = 'reports/evaluation-management-report/individual-list'

// resident-incident-report api
export const residentIncidentReportApi = 'reports/resident-incident-report/list'

// school transfer report api
export const schoolTransferReportApi = 'reports/school-transfer-report/list'

// Assign to school report api
export const assignToSchoolReportApi = 'reports/assign-to-school-report/list'
// get the student List by institute
 export const studentListApi = 'reports/evaluation-management-report/get-student'
 // get the Child List by institute
 export const childListApi = 'reports/case-file-report/get-child'

 // Legal Resident Summary Report api
export const legalResidentSummaryReportApi = 'reports/legal-resident-summary-report/list'

// case-type-wise-legal-resident-report
export const caseTypeWiseLegalReportApi = 'reports/case-type-wise-legal-resident-report/list'
// court attendance report api
export const courtAttendanceReportApi = 'reports/court-attendance-report/list'
